// v0.8.4 — 时段预留 Modal (辉哥 10/6 拍板)
// 决策 ③ notes 选填
// Modal: 只有时段摘要 + 原因输入框, 无时长栏
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
// v0.19.22 — 后端错误文案的**共用入口** (三级兜底 + 过滤 '[object Object]', 与本文件历史手抄版逐字等价)
import { errReasonSafe } from '../utils/FormPrimitives';

/**
 * attrs:
 *   - reservation: { id, school_id, room_id, start_at, end_at, notes, creator }
 *   - roomName: string
 *   - timeRange: 'HH:MM - HH:MM'
 *   - onSubmit(notes): Promise
 *   - onCancel(): 取消回调
 */
export default class ReservationModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.reservation = vnode.attrs.reservation;
    this.roomName = vnode.attrs.roomName || '';
    this.timeRange = vnode.attrs.timeRange || '';
    this.notes = this.reservation && this.reservation.notes || '';
    this.saving = false;
    this.errorMsg = '';
  }
  className() {
    return 'Modal--medium ZS-BookingModal ZS-ReservationModal';
  }
  title() {
    return '时段预留';
  }

  // v0.8.4 — Flarum 2.0 Modal 基类的抽象方法是 content() (不是 view()!)
  //   BookingModal 历史上也没显式 override, 走基类默认 inner() → content() 链
  //   这里显式 content(), Modal 框架会自己包 Modal.modal-dialog + Modal-content + Modal-header 套子
  content() {
    const r = this.reservation;
    const headerTimeRange = this.timeRange || (r ? this._fmtRange(r.start_at, r.end_at) : '');
    return m("div", {
      className: "Modal-body ZS-rsv"
    }, m("div", {
      className: "ZS-rsv-hd"
    }, m("div", {
      className: "ZS-rsv-hdicon"
    }, m("i", {
      class: "fas fa-lock"
    })), m("div", null, m("div", {
      className: "ZS-rsv-hdt"
    }, "\u65F6\u6BB5\u9884\u7559"), m("div", {
      className: "ZS-rsv-hds"
    }, "\u4EC5\u5360\u4F4D, \u4E0D\u4F1A\u81EA\u52A8\u53D6\u6D88\u5DF2\u6709\u8BFE"))), m("div", {
      className: "ZS-rsv-slot"
    }, m("i", {
      class: "fas fa-clock ZS-rsv-slotico"
    }), m("div", {
      className: "ZS-rsv-slotmain"
    }, m("div", {
      className: "ZS-rsv-slott"
    }, this.roomName || '未指定教室', " \xB7 ", headerTimeRange), m("div", {
      className: "ZS-rsv-slots"
    }, "\u521B\u5EFA\u540E\u8BE5\u65F6\u6BB5\u88AB\u9501\u4F4F, \u65B0\u7EA6\u8BFE\u4F1A\u88AB\u62D2\u7EDD"))), m("label", {
      className: "ZS-rsv-fl"
    }, "\u9884\u7559\u539F\u56E0 (\u9009\u586B)"), m("input", {
      className: "ZS-rsv-in",
      type: "text",
      placeholder: "\u4F8B: \u8BBE\u5907\u7EF4\u62A4 / \u56E2\u961F\u590D\u76D8 / \u4E34\u65F6\u4F1A\u8BAE\u5BA4...",
      value: this.notes,
      maxlength: "255",
      oninput: e => {
        this.notes = e.target.value;
      }
    }), this.errorMsg && m("div", {
      className: "ZS-rsv-warn"
    }, m("i", {
      class: "fas fa-triangle-exclamation"
    }), m("span", null, this.errorMsg)), m("div", {
      className: "ZS-rsv-btns"
    }, m("button", {
      className: "ZS-rsv-btn",
      type: "button",
      onclick: () => this.attrs.onCancel && this.attrs.onCancel()
    }, m("i", {
      class: "fas fa-xmark"
    }), m("span", null, "\u53D6\u6D88")), m("button", {
      className: 'ZS-rsv-btn is-primary' + (this.saving ? ' is-loading' : ''),
      type: "button",
      disabled: this.saving,
      onclick: () => this._submit()
    }, m("i", {
      class: "fas fa-check"
    }), m("span", null, this.saving ? '保存中...' : '确认预留'))));
  }
  async _submit() {
    if (this.saving) return;
    this.saving = true;
    this.errorMsg = '';
    try {
      await this.attrs.onSubmit(this.notes);
      app.modal.close();
    } catch (e) {
      this.saving = false;
      const detail = errReasonSafe(e, '保存失败');
      this.errorMsg = detail;
      m.redraw();
    }
  }
  _fmtRange(start_at, end_at) {
    const fmt = s => {
      if (!s) return '';
      const d = new Date(s.replace(' ', 'T'));
      return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    };
    return fmt(start_at) + ' - ' + fmt(end_at);
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/modal/ReservationModal', ReservationModal);